import { render, staticRenderFns } from "./DocumentCategoryList.vue?vue&type=template&id=313c84c5&"
import script from "./DocumentCategoryList.vue?vue&type=script&lang=js&"
export * from "./DocumentCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports